'use client'

import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import ProductCard from '@/components/Catalog/ProductCard'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import { useProductFilters, useProducts } from '@/hooks/business/catalog'
import InexistentSearch from '../InexistentSearch'

/**
 * Grade da listagem `/produtos` com rolagem infinita: os produtos dos filtros da URL, a próxima página quando o fim da
 * lista aparece e o aviso de busca vazia (também quando a listagem falha, como a loja sempre fez). Ao trocar o filtro,
 * a lista anterior fica na tela até a nova chegar.
 */
export default function ProductsGrid() {
    const { filters } = useProductFilters()
    const { products, hasMore, loadMore, isLoading } = useProducts({ filters })
    const { ref, inView } = useInView()

    useEffect(() => {
        if (inView && hasMore) void loadMore()
    }, [inView, hasMore, loadMore])

    return (
        <>
            {products.length > 0 ? (
                <div className="grid w-full grid-flow-row grid-cols-3 gap-4 p-0 max-md:grid-cols-1 max-lg:grid-cols-2">
                    {products.map((product) => (
                        <ProductCard key={product.id} data={product} />
                    ))}
                </div>
            ) : !isLoading ? (
                <InexistentSearch />
            ) : null}
            {(hasMore || isLoading) && (
                <div ref={ref} className="flex flex-row items-center justify-center w-full h-12 text-center ">
                    <LoadingSpinner />
                    <span className="text-xl font-light text-gray-400">Carregando produtos...</span>
                </div>
            )}
        </>
    )
}
